<template>
    <div class="container-fluid px-0">

        <!-- Nav (Small screens) -->
        <div class="d-md-none d-flex align-items-center justify-content-between small-nav">
            <!-- Back icon -->
            <a v-load-page="'/'" v-ripple class="navbar-brand fw-bold fs-4 py-0 m-0 rounded-circle">
                <i class="hoverable-icon bi-arrow-left"></i>
            </a>
            <!-- Menu toggler -->
            <i class="hoverable-icon bi-three-dots-vertical" data-bs-toggle="dropdown" data-bs-auto-close="outside"
                aria-expanded="false" v-ripple></i>
            <ul class="dropdown-menu">
                <li>
                    <a class="dropdown-item cursor-pointer" v-load-page="'/settings'" v-ripple>
                        <i class="me-3 bi-gear"></i>
                        Settings
                    </a>
                    <hr class="dropdown-divider">
                    <a class="dropdown-item cursor-pointer" v-load-page="'/logout'" v-ripple>
                        <i class="me-3 bi-box-arrow-right"></i>
                        Sign out
                        <i class="ms-auto bi-arrow-right ms-auto"></i>
                    </a>
                </li>
            </ul>
        </div>

        <NavButtons light-btns></NavButtons>
        <!-- Profile Section -->
        <div class="row profile-section gy-4 mb-0" :class="width < 768 ? '' : 'mb-medium'">
            <div class="col-12 col-md-auto mt-0 me-md-5px">
                <img class="profile-img rounded-circle" src="https://picsum.photos/200/300" />
            </div>
            <div class="d-flex flex-column justify-content-center col-12 col-md-auto mt-0">
                <h4 class="mb-2 fw-semi-bold mt-4 mt-md-0 mb-4">{{ auth.user.username }}</h4>
                <div class="d-flex justify-content-center gap-5 text-center">
                    <div class="d-flex flex-column">
                        <p class="m-0 fs-5 fw-bold">1234</p>
                        <p class="text-muted m-0">Follow</p>
                    </div>
                    <div class="d-flex flex-column">
                        <p class="m-0 fs-5 fw-bold">654</p>
                        <p class="text-muted m-0">Appreciations</p>
                    </div>
                    <div class="d-flex flex-column">
                        <p class="m-0 fs-5 fw-bold">981</p>
                        <p class="text-muted m-0">Views</p>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Tab headings -->
    <Swiper id="mainTabsContainer" class="nav nav-tabs align-items-end border-0 in-page-swiper" role="tablist" tag="ul">
        <template #content>
            <li class="nav-item align-items-center h-100" role="presentation" v-for="(tab, index) in tabs">
                <button class="nav-link h-100 p-0" :class="index == 0 ? 'active' : ''" data-bs-toggle="tab"
                    :data-bs-target="`#tab-${index}-pane`" type="button" role="tab" v-ripple>
                    {{ tab }}
                </button>
            </li>
        </template>
    </Swiper>

    <!-- Divider -->
    <div class="divider sm mb-2"></div>

    <!-- Tabs content -->
    <div class="tab-content">
        <!-- Tab container -->
        <div class="tab-pane" :class="index == 0 ? 'show active' : ''" :id="`tab-${index}-pane`" role="tabpanel"
            tabindex="0" v-for="(tab, index) in tabs">
            <div class="tab-items">
                <SurveyCardsContainer />
            </div>
        </div>
    </div>
</template>

<script setup>
import { onMounted, ref } from "vue";
import { useWindowSize } from "@vueuse/core";
import Swiper from "@/components/Swiper.vue";
import SurveyCardsContainer from "@/components/SurveyCard/SurveyCardsContainer.vue";
import tab from "bootstrap/js/dist/tab";
import { useAuthStore } from "@/stores/auth-store";
import { useAppHelpers } from '@/composables/useAppHelpers';
import NavButtons from "@/components/NavButtons.vue";

const helper = useAppHelpers();
const auth = useAuthStore();
const { width } = useWindowSize();

const nextTabReady = ref(false);
const tabs = ["Surveys"];

onMounted(() => {
    const tabEls = document.querySelectorAll('#mainTabsContainer button[data-bs-toggle="tab"]')
    tabEls.forEach((tabEl) => {
        tabEl.addEventListener('hide.bs.tab', event => {
            if (!nextTabReady.value) {
                event.preventDefault();
                const currTabBtn = event.target;
                const currentTabId = currTabBtn.dataset.bsTarget
                const currentTab = document.querySelector(currentTabId)
                const currentTabItemsContainer = currentTab.querySelector(".tab-items");

                //Show loading indicator and set opacity for fade effect
                helper.loaderOn(currentTabItemsContainer);

                setTimeout(() => {
                    helper.loaderOff(currentTabItemsContainer);
                    nextTabReady.value = true;
                    const nextTabBtn = event.relatedTarget;
                    const nextTab = tab.getOrCreateInstance(nextTabBtn);
                    nextTab.show();
                }, 1000);
            } else {
                nextTabReady.value = false;
            }
        })
    })
})
</script>

<style scoped lang="scss">
.profile-section {
    margin-top: 3rem;

    @media (max-width: 767px) {
        margin-top: -17px;
        text-align: center;
    }

    .profile-img {
        height: 8em;
        width: 8em;
        object-fit: cover;
    }
}

.mt-36 {
    margin-top: 36px;
}

.me-md-5px {
    @media (min-width: 767px) {
        margin-right: 5px;
    }
}

#mainTabsContainer {
    gap: 1.75rem;
}
</style>